import { useCallback } from "react";

export default function useRecaptcha() {

  const getResponse = useCallback((widgetId = null) => {
    if (!window.grecaptcha) {
      console.error("reCAPTCHA not loaded");
      return null;
    }
    return widgetId !== null ? window.grecaptcha.getResponse(widgetId) : window.grecaptcha.getResponse();
  }, []);

  return { getResponse };
}